import React from "react";
import styled from "styled-components/macro";
import tuluLogoBlack from "../images/tuluLogoBlack.svg";
import appStoreBadgeBlack from "../images/appStoreBadgeBlack.svg";
import googlePlayBadgeBlack from "../images/googlePlayBadgeBlack.svg";
import getAppQrCode from "../images/getAppQrCode.png";
import getAppPhoneMockup from "../images/getAppPhoneMockup.webp";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/tulu-own-less-live-more/id1477180604";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.tulou.app&hl=en&gl=US";

const GetApp = () => {
  return (
    <PageWrapper>
      <ContentColumn>
        <TuluLogoImage src={tuluLogoBlack} alt="TULU" />
        <TextBlock>
          <PageTitle>Download the TULU app</PageTitle>
          <PageSubtitle>
            24/7 access to the best household and lifestyle products
          </PageSubtitle>
        </TextBlock>
        <DownloadOptionsRow>
          <StoreBadgesColumn>
            <a href={APP_STORE_URL}>
              <img src={appStoreBadgeBlack} alt="Download on the App Store" />
            </a>
            <a href={GOOGLE_PLAY_URL}>
              <img src={googlePlayBadgeBlack} alt="Get it on Google Play" />
            </a>
          </StoreBadgesColumn>
          <QrCodeWrapper>
            <img src={getAppQrCode} alt="QR code to download the TULU app" />
          </QrCodeWrapper>
        </DownloadOptionsRow>
      </ContentColumn>

      <PhoneMockupWrapper>
        <img src={getAppPhoneMockup} alt="The TULU app on a phone" />
      </PhoneMockupWrapper>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: clamp(60px, 10vw, 200px);
  min-height: 100vh;
  padding: 40px clamp(24px, 10vw, 200px);
  box-sizing: border-box;
  background-color: #ffffff;
  font-family: "Poppins", sans-serif;
  color: #000000;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 48px;
    padding: 48px 24px;
  }
`;

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(60px, 8vw, 150px);
  width: min(600px, 100%);

  @media (max-width: 768px) {
    align-items: center;
    gap: 40px;
  }
`;

const TuluLogoImage = styled.img`
  width: 100px;
  height: 23px;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const PageTitle = styled.p`
  margin: 0;
  font-size: clamp(30px, 2.6vw, 40px);
  font-weight: 600;
  text-transform: capitalize;
`;

const PageSubtitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const DownloadOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(40px, 5vw, 100px);
`;

const StoreBadgesColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;

  img {
    display: block;
    width: 200px;
    height: 67px;
  }

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const QrCodeWrapper = styled.div`
  width: 220px;
  height: 220px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const PhoneMockupWrapper = styled.div`
  width: clamp(320px, 31vw, 600px);
  flex-shrink: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    filter: drop-shadow(4px 4px 20px rgba(0, 0, 0, 0.2));
  }

  @media (max-width: 768px) {
    width: min(75%, 320px);
    flex-shrink: 1;
  }
`;

export default GetApp;
